module.exports = {"411671011":"太昊路街道","411671012":"淮河路街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411671.json
// module id = 1807
// module chunks = 0